import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { useQueryParam } from 'javascripts/hooks/use-query-param';

import ChirpPropShapes from 'javascripts/shared/chirp_prop_shapes';

import { ChirpButton } from 'javascripts/components/chirp_button';
import { SocialSharingModal } from 'javascripts/components/social_sharing_modal';

import { bubEvents } from 'javascripts/shared/events/bub_events';
import { SocialSharing } from 'javascripts/shared/utils/social_sharing';

import shareIcon from 'images/share.svg';

export function GeneralSharingButton({ audiobook, shareText, small, yellow, socialSharingProps, nativeShareText, context }) {
  const [openShare] = useQueryParam('open_share');

  const title = document.title;
  const text = useMemo(() => {
    return nativeShareText || `I think you'd like this audiobook from Chirp: ${audiobook.displayTitle}`;
  });

  const socialSharing = useMemo(() => {
    return new SocialSharing(socialSharingProps);
  }, []);

  const url = socialSharing.generateShareUrl('device_share');
  const [showSharingButtonsModal, setShowSharingButtonsModal] = useState(openShare);

  function handleClick() {
    if (navigator.share) {
      navigator
        .share({
          title,
          url,
          text,
        })
        .then(() => {
          bubEvents.track('Sharing Component', 'Clicked button', {
            label: 'Share',
            type: 'native',
            context,
            audiobookId: audiobook.id
          });
        });
    } else {
      setShowSharingButtonsModal(true);

      bubEvents.track('Sharing Component', 'Clicked button', {
        label: 'Share',
        type: 'modal',
        context,
        audiobookId: audiobook.id
      });
    }
  }

  function renderButton() {
    if (yellow) {
      return(
        <ChirpButton
          attrs={{ rel: 'nofollow' }}
          displayStyle='yellow'
          label={shareText}
          fullWidth
          onClick={handleClick}
          fontSize={small ? 'medium' : 'large'}
        />
      );
    }

    return(
      <ChirpButton
        attrs={{ rel: 'nofollow' }}
        displayStyle='gray'
        displayStyleHover='navy'
        displayType='link'
        icon={shareIcon}
        iconHover={shareIcon}
        label={shareText}
        onClick={handleClick}
        fontSize={small ? 'small' : 'medium'}
      />
    );
  }

  return (
    <>
      {renderButton()}

      <SocialSharingModal
        isOpen={showSharingButtonsModal}
        onRequestClose={() => setShowSharingButtonsModal(false)}
        audiobook={audiobook}
        socialSharingProps={socialSharingProps}
      />
    </>
  );
}

GeneralSharingButton.propTypes = {
  audiobook: ChirpPropShapes.audiobook.isRequired,
  shareText: PropTypes.string,
  small: PropTypes.bool,
  yellow: PropTypes.bool,
  socialSharingProps: PropTypes.object,
  nativeShareText: PropTypes.string,
  context: PropTypes.string,
};

GeneralSharingButton.defaultProps = {
  omitSource: false,
  shareText: 'Share',
  small: false,
  yellow: false,
  socialSharingProps: {},
  context: null,
};
